(function ($) {
	jQuery("body").on("change", ".blog-listing select", function () {
		let category = $("#category-filter").val();
		let sortFilter = $("#sort-filter").val();
		$.ajax({
			type: "post",
			dataType: "json",
			url: ElementorProFrontendConfig.ajaxurl,
			data: {
				action: "filterPost",
				category,
				sortFilter,
			},
			context: this,
			beforeSend: function () {},
			success: function (response) {
				$(".list-post").html(response.data);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log(
					"The following error occured: " + textStatus,
					errorThrown
				);
			},
		});
	});

	jQuery("body").on(
		"click",
		".blog-listing .pagination a.page-numbers",
		function (event) {
			event.preventDefault();
			let category = $("#category-filter").val();
			let sortFilter = $("#sort-filter").val();
			let paged = $(this).text();
			$.ajax({
				type: "post",
				dataType: "json",
				url: ElementorProFrontendConfig.ajaxurl,
				data: {
					action: "paginationPost",
					category,
					sortFilter,
					paged,
				},
				context: this,
				beforeSend: function () {},
				success: function (response) {
					$(".list-post").html(response.data);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.log(
						"The following error occured: " + textStatus,
						errorThrown
					);
				},
			});
		}
	);

	jQuery("#category-filter").multiselect({
		placeholder: "Select categories",
		search: false,
		numberDisplayed: 1,
		selectAll: false,
	});

	jQuery("#sort-filter").multiselect({
		placeholder: "Sort by",
		search: false,
		numberDisplayed: 1,
		selectAll: false,
	});
})(jQuery);
